// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard-pageContainer-PL4xT {
	width: 100%;
	max-width: var(--max-listing-width);
	margin: 0 auto;
}

.Dashboard-avatarSection-B4fcD {
	display: block;
	padding: 24px 24px 0px;
}

.Dashboard-avatarSectionBorder-yTIcI {
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.Dashboard-bgColor-mRuSG {
	background-color: var(--dashBoard-info-bg);
}

.Dashboard-handIconGrid-CJnlc {
	display: grid;
	grid-template-columns: 500px auto;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Dashboard-btnDisplayGrid-e1tjH {
	display: grid;
	grid-template-columns: 54px auto;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 12px 23px 12px 12px;
}

.Dashboard-btnDisplayFlex-Wygte {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Dashboard-btnMainGrid-k4geY {
	display: grid;
	grid-template-columns: 31% 38% 31%;
}

.Dashboard-reviewMargin-DEou4 {
	margin: 0px 18px !important;
}

.Dashboard-viewProfileGrid-V31Xs {
	padding: 24px;
	grid-template-columns: 30px auto;
}

@media (min-width: 768px) and (max-width: 991px) {
	.Dashboard-avatarSection-B4fcD {
		display: block;
		padding: 24px 0 0px;
		width: 150px;
		margin: 0 auto;
	}
}

@media screen and (max-width: 767px) {
	.Dashboard-handIconGrid-CJnlc {
		grid-template-columns: 100%;
	}

	.Dashboard-btnMainGrid-k4geY {
		display: grid;
		grid-template-columns: 100%;
	}

	.Dashboard-reviewMargin-DEou4 {
		margin: 18px 0px !important;
	}

	.Dashboard-avatarSection-B4fcD {
		padding: 24px 0 0px;
		width: 150px;
		margin: 0 auto;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,aAAa;CACb,iCAAiC;CACjC,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,uCAAuC;CACvC,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,aAAa;EACb,2BAA2B;CAC5B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,mBAAmB;EACnB,YAAY;EACZ,cAAc;CACf;AACD","sourcesContent":[".pageContainer {\n\twidth: 100%;\n\tmax-width: var(--max-listing-width);\n\tmargin: 0 auto;\n}\n\n.avatarSection {\n\tdisplay: block;\n\tpadding: 24px 24px 0px;\n}\n\n.avatarSectionBorder {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.bgColor {\n\tbackground-color: var(--dashBoard-info-bg);\n}\n\n.handIconGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 500px auto;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.btnDisplayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 54px auto;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 12px 23px 12px 12px;\n}\n\n.btnDisplayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.btnMainGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 31% 38% 31%;\n}\n\n.reviewMargin {\n\tmargin: 0px 18px !important;\n}\n\n.viewProfileGrid {\n\tpadding: 24px;\n\tgrid-template-columns: 30px auto;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n\t.avatarSection {\n\t\tdisplay: block;\n\t\tpadding: 24px 0 0px;\n\t\twidth: 150px;\n\t\tmargin: 0 auto;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.handIconGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.btnMainGrid {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.reviewMargin {\n\t\tmargin: 18px 0px !important;\n\t}\n\n\t.avatarSection {\n\t\tpadding: 24px 0 0px;\n\t\twidth: 150px;\n\t\tmargin: 0 auto;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Dashboard-pageContainer-PL4xT`,
	"avatarSection": `Dashboard-avatarSection-B4fcD`,
	"avatarSectionBorder": `Dashboard-avatarSectionBorder-yTIcI`,
	"bgColor": `Dashboard-bgColor-mRuSG`,
	"handIconGrid": `Dashboard-handIconGrid-CJnlc`,
	"btnDisplayGrid": `Dashboard-btnDisplayGrid-e1tjH`,
	"btnDisplayFlex": `Dashboard-btnDisplayFlex-Wygte`,
	"btnMainGrid": `Dashboard-btnMainGrid-k4geY`,
	"reviewMargin": `Dashboard-reviewMargin-DEou4`,
	"viewProfileGrid": `Dashboard-viewProfileGrid-V31Xs`
};
module.exports = ___CSS_LOADER_EXPORT___;
